// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SingleCardLayout_cardContainer__IV3OV"};